import React from 'react';
import { CalendarIcon, ClockIcon, MapPinIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { getImageUrlWithEnv } from '../utils/imageUrl';

const MatchCard = ({ match, type = 'upcoming', onRefresh }) => {
  const isUpcoming = type === 'upcoming';
  const isPrevious = type === 'previous';

  return (
    <div className={`bg-white rounded-lg shadow-lg p-6 border-l-4 ${
      isUpcoming ? 'border-primary-500' : 
      isPrevious ? 'border-green-500' : 
      'border-gray-300'
    }`}>
      <div className="text-center">
        {/* Match Type Header */}
        <div className="mb-4">
          <div className="flex justify-between items-center">
            <h3 className={`text-lg font-semibold font-georgian ${
              isUpcoming ? 'text-primary-600' : 
              isPrevious ? 'text-green-600' : 
              'text-gray-600'
            }`}>
              {isUpcoming ? 'შემდეგი მატჩი' : 'წინა მატჩი'}
            </h3>
            {onRefresh && (
              <button
                onClick={onRefresh}
                className="text-gray-400 hover:text-primary-600"
                title="განახლება"
              >
                <ArrowPathIcon className="h-4 w-4" />
              </button>
            )}
          </div>
          {match.tournament && (
            <p className="text-sm text-gray-600 font-georgian">{match.tournament}</p>
          )}
        </div>

        {/* Teams */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-2">
              <img 
                src={getImageUrlWithEnv(match.homeTeam.logo)} 
                alt={match.homeTeam.name}
                className="w-12 h-12 object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center text-primary-600 font-bold text-lg" style={{display: 'none'}}>
                {match.homeTeam.name.charAt(0)}
              </div>
            </div>
            <span className="text-sm font-medium text-gray-700 font-georgian text-center">
              {match.homeTeam.name}
            </span>
          </div>

          <div className="flex flex-col items-center">
            {isUpcoming ? (
              <div className="text-center">
                <div className="text-2xl font-bold text-gray-900 font-georgian">
                  VS
                </div>
              </div>
            ) : (
              <div className="text-center">
                <div className="text-3xl font-bold text-gray-900 font-georgian">
                  {match.score}
                </div>
                <div className="text-sm text-gray-500 font-georgian">შედეგი</div>
              </div>
            )}
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-2">
              <img 
                src={getImageUrlWithEnv(match.awayTeam.logo)} 
                alt={match.awayTeam.name}
                className="w-12 h-12 object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center text-primary-600 font-bold text-lg" style={{display: 'none'}}>
                {match.awayTeam.name.charAt(0)}
              </div>
            </div>
            <span className="text-sm font-medium text-gray-700 font-georgian text-center">
              {match.awayTeam.name}
            </span>
          </div>
        </div>

        {/* Match Details */}
        <div className="space-y-2">
          <div className="flex items-center justify-center text-gray-600">
            <CalendarIcon className="h-4 w-4 mr-2" />
            <span className="text-sm font-georgian">{match.date}</span>
          </div>
          
          {match.time && (
            <div className="flex items-center justify-center text-gray-600">
              <ClockIcon className="h-4 w-4 mr-2" />
              <span className="text-sm font-georgian">{match.time}</span>
            </div>
          )}
          
          <div className="flex items-center justify-center text-gray-600">
            <MapPinIcon className="h-4 w-4 mr-2" />
            <span className="text-sm font-georgian">{match.venue}</span>
          </div>
        </div>

        {/* Action Button */}
        {isUpcoming && (
          <button className="mt-4 bg-primary-600 hover:bg-primary-700 text-white font-bold py-2 px-6 rounded-lg transition-colors duration-200 font-georgian">
            ბილეთების შეძენა
          </button>
        )}
      </div>
    </div>
  );
};

export default MatchCard;
